var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 50,
    height: 50,
    viewBox: "0,0,256,256",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,4c0.56641,0 1.09766,0.21875 1.49609,0.62109l18.88281,18.88281c0.82813,0.82422 0.82813,2.16797 0,2.99219l-18.88281,18.88281c-0.39844,0.40234 -0.92969,0.62109 -1.49609,0.62109c-0.56641,0 -1.09766,-0.21875 -1.49609,-0.62109l-18.88281,-18.88281c-0.82813,-0.82422 -0.82813,-2.16797 0,-2.99219l12.32031,-12.32031l2.27344,2.27344c-0.54687,2.03125 0.00391,4.24609 1.54297,5.78516c0.36719,0.36719 0.78516,0.68359 1.24219,0.94531v9.62891c-1.82031,1.05078 -3,3.00781 -3,5.18359c0,3.30859 2.69141,6 6,6c3.30859,0 6,-2.69141 6,-6c0,-2.17578 -1.17969,-4.13281 -3,-5.18359v-7.57422l1.21484,1.21484c-0.54687,2.03125 0.00391,4.24609 1.54297,5.78516c1.13281,1.13281 2.64063,1.75781 4.24219,1.75781c1.60156,0 3.10938,-0.625 4.24219,-1.75781c2.33984,-2.33984 2.33984,-6.14453 0,-8.48437c-1.12891,-1.12891 -2.625,-1.75 -4.22266,-1.75c-0.52734,0 -1.05469,0.07031 -1.5625,0.20703l-2.67187,-2.67187c0.54688,-2.03125 -0.00391,-4.24609 -1.54297,-5.78516c-1.12891,-1.12891 -2.625,-1.75 -4.22266,-1.75c-0.52734,0 -1.05469,0.07031 -1.5625,0.20703l-2.27344,-2.27344l2.32031,-2.32031c0.39844,-0.40234 0.92969,-0.62109 1.49609,-0.62109M25,2c-1.05469,0 -2.10937,0.40234 -2.91016,1.20703l-3.73437,3.73437l4.62109,4.62109c0.62891,-0.36719 1.33594,-0.55469 2.04297,-0.55469c1.01563,0 2.03125,0.38672 2.80859,1.16406c1.31641,1.31641 1.50781,3.31641 0.60547,4.84766l4.54297,4.54297c0.62891,-0.36719 1.33594,-0.55469 2.04297,-0.55469c1.01563,0 2.03125,0.38672 2.80859,1.16406c1.5625,1.5625 1.5625,4.09375 0,5.65625c-0.78125,0.78125 -1.80469,1.17188 -2.82812,1.17188c-1.02344,0 -2.04687,-0.39062 -2.82812,-1.17187c-1.31641,-1.31641 -1.50781,-3.31641 -0.60547,-4.85156l-4.54297,-4.54297c-0.32422,0.19141 -0.66797,0.33203 -1.02344,0.42188v12.28516c1.72266,0.44531 3,1.99609 3,3.85938c0,2.21094 -1.78906,4 -4,4c-2.20703,0 -4,-1.78906 -4,-4c0,-1.86328 1.27734,-3.41406 3,-3.85937v-12.28516c-0.66797,-0.17187 -1.30469,-0.50391 -1.82812,-1.02734c-1.31641,-1.31641 -1.50781,-3.31641 -0.60547,-4.84766l-4.625,-4.625l-13.73437,13.73438c-1.60938,1.60547 -1.60938,4.21484 0,5.82031l18.88281,18.88281c0.80078,0.80469 1.85547,1.20703 2.91016,1.20703c1.05469,0 2.10938,-0.40234 2.91016,-1.20703l18.88281,-18.88281c1.60938,-1.60547 1.60938,-4.21484 0,-5.82031l-18.88281,-18.88281c-0.80078,-0.80469 -1.85547,-1.20703 -2.91016,-1.20703z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.89b9933edf35166fd9d61a0d6f202186.svg";
export { ForwardRef as ReactComponent };